module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/governmentForms/EForms.ejs -->\n<div class="row wrapper border-bottom white-bg page-heading">\n    <div class="col-xs-12">\n        <h2 class="govt-forms-title">Yearly Forms</h2>\n    </div>\n</div>\n\n<div class="wrapper wrapper-content">\n    <div class="row">\n        <div class="col-sm-12">\n            <div class="ibox float-e-margins">\n                <div class="ibox-content">\n                    <div class="row vertical-align">\n                        <div class="col-sm-1 text-center">\n                            <i class="fa fa-2x fa-info-circle m-t-sm"></i>\n                        </div>\n                        <h3 class="col-sm-11 line-height-md">\n                            Please be reminded to check the forms as it is the\n                            employer\'s responsibility to provide accurate\n                            information to the statutory bodies.\n                        </h3>\n                    </div>\n                </div>\n            </div>\n\n            <div class="ibox float-e-margins">\n                <div class="ibox-title">\n                    ';
 if (collection.length <= 0) { 
__p+='\n                        <h5>No Forms Available</h5>\n                    ';
 } else if (collection.length === 1) { 
__p+='\n                        <h5>'+
((__t=( collection.length ))==null?'':_.escape(__t))+
' E Form</h5>\n                    ';
 } else if (collection.length > 1) { 
__p+='\n                        <h5>'+
((__t=( collection.length ))==null?'':_.escape(__t))+
' E Forms</h5>\n                    ';
 } 
__p+='\n                </div>\n\n                <div class="ibox-content">\n                    <div class="row items">\n                        <div class="col-xs-12">\n                            '+
((__t=( require('commons/templates/Spinner.html')() ))==null?'':__t)+
'\n\n                            <div class="empty-list text-center hidden">\n                                <h1>\n                                    You haven\'t generated an E Form yet.\n                                </h1>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class="ibox-footer text-right">\n                    ';
 if (!hideFormEButton && availableYears.length) { 
__p+='\n                    <select id="year">\n                        ';
 for (var year in availableYears) { 
__p+='\n                            <option value="'+
((__t=( availableYears[year] ))==null?'':_.escape(__t))+
'">'+
((__t=( availableYears[year] ))==null?'':_.escape(__t))+
'</option>\n                        ';
 } 
__p+='\n                    </select>\n                    <button class="btn btn-primary js-generate">\n                        Generate Form\n                    </button>\n                    ';
 } 
__p+='\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/governmentForms/EForms.ejs
// module id = 917
// module chunks = 1